import { Movie } from "../movies";

export function MovieCard({ movie }: { movie: Movie }) {
    return (
        <div className="flex flex-col items-center">
            <img className="h-64" src={movie.image} alt="Movie's poster" />
            <p className="text-lg font-bold text-center">{movie.title}</p>
        </div>
    );
}